import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Outlet, useNavigate } from 'react-router-dom'
import './styles.scss'
import {
  solid,
  regular,
  brands,
} from '@fortawesome/fontawesome-svg-core/import.macro'
import logo1 from '../../Assets/Images/expeditors.png'
import NavItem from '../NavItem'
import { ROUTES, SERVICES } from '../../constants'
import { useScrollPosition } from '../../Hooks/useScrollPosition'
import { useState } from 'react'
import Overlay from '../Overlays'
import QuoteForm from './QuoteForm'
import CustomButton from '../CustomButton'
import FooterLink from './FooterLink'
import AnimateHeight from 'react-animate-height'

const Layout = () => {
  const navigate = useNavigate()

  const goToAboutUs = () => navigate(ROUTES.about)

  const scrollPosition = useScrollPosition()

  const [isOpen, setIsOpen] = useState(false)
  const toggleOverlay = () => setIsOpen((prev) => !prev)

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
    setIsServicesMenuOpen(false)
  }

  const [isServicesMenuOpen, setIsServicesMenuOpen] = useState(false)

  const isScrolled = scrollPosition > 50

  const onMenuItemSelected = (route, value) => () => {
    navigate(route, { state: { service: value } })
    closeMobileMenu()
  }

  return (
    <div className="layout">
      {/* ── Desktop header ── */}
      <header
        className={`layout__menu${isScrolled ? ' layout__menu--scrolled' : ''}`}
      >
        {!isScrolled && (
          <div className="layout__menu__socials">
            <div className="layout__menu__socials__info">
              <span>
                <FontAwesomeIcon className="icon" icon={solid('phone')} />{' '}
                +1 (212) 235-2008
              </span>
              <span>
                <FontAwesomeIcon className="icon" icon={regular('envelope')} />{' '}
                business@expeditorslogistics.live
              </span>
              <span>
                <FontAwesomeIcon className="icon" icon={solid('location-dot')} />{' '}
                Global Facility Office
              </span>
            </div>
            <div className="layout__menu__socials__links">
              <div><FontAwesomeIcon icon={brands('facebook-f')} /></div>
              <div><FontAwesomeIcon icon={brands('linkedin-in')} /></div>
              <div><FontAwesomeIcon icon={brands('twitter')} /></div>
            </div>
          </div>
        )}

        {isScrolled && (
          <div className="layout__menu__compact-info">
            <span>
              <FontAwesomeIcon icon={solid('phone')} />
              +1 (212) 235-2008
            </span>
            <span>
              <FontAwesomeIcon icon={regular('envelope')} />
              business@expeditorslogistics.live
            </span>
          </div>
        )}

        <div className="layout__menu__content">
          <img
            className="layout__menu__logo"
            onClick={() => navigate('/')}
            src={logo1}
            alt="Logo"
          />
          <nav className="layout__menu__nav">
            <NavItem label="Home" route="/" />
            <NavItem label="About Us" route={ROUTES.about} />
            <NavItem
              label="Services"
              options={['Air Freight', 'Ocean Freight', 'Cargo Transportation', 'Packaging and Storage']}
              hasDropDown
              route={ROUTES.services}
            />
            <NavItem label="Track Your Package" route={ROUTES.trackIt} />
            <NavItem label="Contact Us" route={ROUTES.contact} />
          </nav>
          <button className="get-quote" onClick={toggleOverlay}>
            <FontAwesomeIcon className="icon" icon={regular('envelope')} />
            Get A Quote
          </button>
        </div>
      </header>

      {/* ── Mobile top bar ── */}
      <header className="layout__menu-mobile">
        <div className="layout__menu-mobile__top">
          <img onClick={() => navigate('/')} src={logo1} alt="Logo" />
          <div
            className={`hambug${isMobileMenuOpen ? ' hambug--open' : ''}`}
            onClick={() => setIsMobileMenuOpen((p) => !p)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </div>
        </div>
      </header>

      {/* ── Mobile drawer ── */}
      <div className={`mobile-drawer${isMobileMenuOpen ? ' mobile-drawer--open' : ''}`}>
        {/* Drawer header */}
        <div className="mobile-drawer__header">
          <img
            className="mobile-drawer__logo"
            src={logo1}
            alt="Logo"
            onClick={onMenuItemSelected('/')}
          />
          <button className="mobile-drawer__close" onClick={closeMobileMenu} aria-label="Close menu">
            <FontAwesomeIcon icon={solid('xmark')} />
          </button>
        </div>

        {/* Nav links */}
        <nav className="mobile-drawer__nav">
          <div className="mobile-drawer__item" onClick={onMenuItemSelected('/')}>
            <FontAwesomeIcon className="item-icon" icon={solid('house')} />
            <span>Home</span>
          </div>

          <div className="mobile-drawer__item" onClick={onMenuItemSelected(ROUTES.about)}>
            <FontAwesomeIcon className="item-icon" icon={solid('users')} />
            <span>About Us</span>
          </div>

          <div className="mobile-drawer__item mobile-drawer__item--accordion">
            <div
              className="mobile-drawer__item__row"
              onClick={() => setIsServicesMenuOpen((p) => !p)}
            >
              <div className="mobile-drawer__item__left">
                <FontAwesomeIcon className="item-icon" icon={solid('boxes-stacked')} />
                <span>Services</span>
              </div>
              <FontAwesomeIcon
                className={`chevron${isServicesMenuOpen ? ' chevron--open' : ''}`}
                icon={solid('chevron-down')}
              />
            </div>

            <AnimateHeight duration={280} height={isServicesMenuOpen ? 'auto' : 0}>
              <div className="mobile-drawer__sub-items">
                {['Air Freight', 'Ocean Freight', 'Cargo Transportation', 'Packaging and Storage'].map((opt) => (
                  <div
                    key={opt}
                    className="mobile-drawer__sub-item"
                    onClick={onMenuItemSelected(ROUTES.services, opt)}
                  >
                    {opt}
                  </div>
                ))}
              </div>
            </AnimateHeight>
          </div>

          <div className="mobile-drawer__item" onClick={onMenuItemSelected(ROUTES.trackIt)}>
            <FontAwesomeIcon className="item-icon" icon={solid('location-dot')} />
            <span>Track Your Package</span>
          </div>

          <div className="mobile-drawer__item" onClick={onMenuItemSelected(ROUTES.contact)}>
            <FontAwesomeIcon className="item-icon" icon={solid('envelope')} />
            <span>Contact Us</span>
          </div>
        </nav>

        {/* Drawer footer */}
        <div className="mobile-drawer__footer">
          <button className="mobile-drawer__quote-btn" onClick={() => { closeMobileMenu(); toggleOverlay() }}>
            <FontAwesomeIcon icon={regular('envelope')} />
            Get A Free Quote
          </button>
          <div className="mobile-drawer__contact-info">
            <span>
              <FontAwesomeIcon icon={solid('phone')} />
              +1 (212) 235-2008
            </span>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      {isMobileMenuOpen && (
        <div className="mobile-backdrop" onClick={closeMobileMenu} />
      )}

      <div className="layout__content">
        <Outlet />
      </div>

      <footer className="layout__footer">
        <div className="layout__footer__light">
          <div className="footer__section">
            <img onClick={() => navigate('/')} src={logo1} alt="Logo" />
            <p>
              We're one of the leading independent shipping and logistics
              providers. Trusted since 1995 by some of the world's leading
              companies...
            </p>
            <CustomButton label={'Read More'} otherClassName="read-more" onClick={goToAboutUs} />
          </div>

          <div className="footer__section">
            <h5>OUR SERVICES</h5>
            <FooterLink label="Air Freight" route={ROUTES.services} state={{ service: SERVICES[0] }} />
            <FooterLink label="Ocean Freight" route={ROUTES.services} state={{ service: SERVICES[1] }} />
            <FooterLink label="Cargo Transportation" route={ROUTES.services} state={{ service: SERVICES[2] }} />
            <FooterLink label="Packaging and Storage" route={ROUTES.services} state={{ service: SERVICES[3] }} />
          </div>

          <div className="footer__section">
            <h5>USEFUL LINKS</h5>
            <FooterLink label="About Us" route={ROUTES.about} />
            <FooterLink label="Contact Us" route={ROUTES.contact} />
            <FooterLink label="Track Your Package" route={ROUTES.trackIt} />
            <FooterLink label="Get A Quote" route={ROUTES.contact} />
          </div>

          <div className="footer__section">
            <h5>LOCATION</h5>
            <div className="location">
              <FontAwesomeIcon className="icon" icon={solid('location-dot')} />
              <div>
                <span>Location:</span>
                <span>GLOBAL FACILITY OFFICE</span>
              </div>
            </div>
            <div style={{ height: 48 }}></div>
            <h5>CALL CENTER</h5>
            <div className="call-center">
              <FontAwesomeIcon className="icon" icon={solid('phone')} />
              <div>
                <span>Call Us:</span>
                <span>+1 (212) 235-2008</span>
              </div>
            </div>
          </div>
        </div>

        <div className="layout__footer__darker">
          <div className="copy-right-text">
            © {new Date().getFullYear()} Expeditors Logistics - All rights reserved
          </div>
          <ul className="social-media-list">
            <FontAwesomeIcon icon={brands('facebook-f')} />
            <FontAwesomeIcon icon={brands('linkedin-in')} />
            <FontAwesomeIcon icon={brands('twitter')} />
          </ul>
        </div>
      </footer>

      <Overlay isOpen={isOpen} onClose={toggleOverlay}>
        <QuoteForm showForm={isOpen} handleClose={() => setIsOpen(false)} />
      </Overlay>
    </div>
  )
}

export default Layout
